import Vue from 'vue';
import VueSocialSharing from 'vue-social-sharing';

Vue.use(VueSocialSharing);